
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { HistoryFollowUpBooking, ActivitiesFollowUpBooking, HistoryFollowUpBookingFilterRequest  } from '@/domain/entities/HangingBooking';
import { debounce } from "lodash";
import { Pagination } from "@/domain/entities/Pagination";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import moment from "moment";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

@Options({
  components: {
    PaginationV3,
  }
})

class TabRiwayatFollowUpBooking extends Vue {
  isLoading = false;
  errorState = "";
  filterDate = new Date();
  filter = new HistoryFollowUpBookingFilterRequest();
  historyFollowUpBooking: HistoryFollowUpBooking[] = [];
  pagination = new Pagination(1, 10)
  maxDate = new Date();

  get renderedData() {
    return this.historyFollowUpBooking.flatMap((obj) => obj.activities).length
  }

  setDateRange([startDate, endDate]: string[]) {
    this.filter = new HistoryFollowUpBookingFilterRequest({
      ...this.filter,
      page: 1,
      startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : "",
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : ""
    });
    startDate && endDate && this.getFilter(this.filter);
  }

  get activityType() {
    return [
      { name: this.$t("dashboard.hanging.allActivities"), value: "" },
      { name: this.$t("dashboard.hanging.followUpPartnerClient"), value: "follow_up_partner_client" },
      { name: this.$t("dashboard.hanging.followUpUser"), value: "follow_up_username" },
      { name: this.$t("dashboard.hanging.searchItemWarehouse"), value: "follow_up_warehouse" }
    ];
  }

  activityTypeSelect = false;
  onOpenActivityType(value: boolean) {
    this.activityTypeSelect = value;
  }

  onSelectActivityType(_: string, value: string) {
    this.filter.page = 1;
    this.filter.activityType = value;
    this.onOpenActivityType(false);
    this.getFilter(this.filter);
  }

  async mounted() {
    await this.getHistoryFollowUpBooking(new HistoryFollowUpBookingFilterRequest());
  }

  getFilter = debounce((filter: Partial<HistoryFollowUpBookingFilterRequest>) => {
    this.filter = new HistoryFollowUpBookingFilterRequest(filter);
    this.getHistoryFollowUpBooking(this.filter);
  }, 250);

  async getHistoryFollowUpBooking(params: HistoryFollowUpBookingFilterRequest) {
    try {
      this.errorState = "";
      this.isLoading = true;
      const res = await SttHangingController.getHistoryFollowUpBooking(params);
      this.historyFollowUpBooking = res.data;
      this.pagination = res.pagination
    } catch (err) {
      this.errorState = err.response ? "server" : "internet";
    } finally {
      this.isLoading = false;
    }
  }

  async toPage(page: number) {
    if (page === this.pagination.page) {
      return;
    }
    this.pagination.page = page;
    this.filter = new HistoryFollowUpBookingFilterRequest({
      ...this.filter,
      page: page
    });
    await this.getHistoryFollowUpBooking(this.filter);
  }

  mapActivityType(activitie: ActivitiesFollowUpBooking) {
    const label: any = {
      "follow_up_partner_client": `${this.$t("dashboard.hanging.followUpTo")} ${activitie.followUp?.partnerName}`,
      "follow_up_username": `${this.$t("dashboard.hanging.followUpTo")} ${activitie.followUp?.username}`,
      "follow_up_warehouse": this.$t("dashboard.hanging.searchSttWarehouse"),
    }

    const icon: any = {
      "follow_up_partner_client": activitie.followUp?.partnerType === "client" ? "ic_followup_client" : "ic_followup_console",
      "follow_up_username": "ic_pic",
      "follow_up_warehouse": "ic_search_hanging"
    }

    return {
      label: label[activitie.activityType] ?? "-",
      icon: icon[activitie.activityType] ?? "ic_pic"
    }
  }

  formatDateToString(date: string) {
    return formatDate(date);
  }
}
export default TabRiwayatFollowUpBooking;
